module.exports = __webpack_public_path__ + "img/productBgImg26.da466b96.png";